import React from "react";
import { NavDropdown } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { FaAngleDown } from "react-icons/fa";
import styled from "styled-components";

const DropPersona = () => {
  const NavDropdownTitle = (
    <span style={{ color: "#fff", marginRight: "20px" }}>
      <StaticImage
        src="../../../assets/images/emoji.png"
        alt="Cuenta"
        placeholder="blurred"
        width={28}
        className="mr-1"
      />
      Persona <FaAngleDown />
    </span>
  );
  return (
    <Wrapper title={NavDropdownTitle} className="btn btn-primary">
      <NavDropdown.Item href="#/action-1">
        <StaticImage
          className="mr-1"
          width={22}
          src="../../../assets/images/emoji-light.png"
          alt="emoji"
        />
        Persona
      </NavDropdown.Item>
      <NavDropdown.Item href="#/action-2">
        <StaticImage
          className="mr-1"
          width={22}
          src="../../../assets/images/pymes.png"
          alt="pymes"
        />
        PYMES
      </NavDropdown.Item>
      <NavDropdown.Item href="#/action-3">
        <StaticImage
          className="mr-1"
          width={22}
          src="../../../assets/images/sind.png"
          alt="sind"
        />
        Sindicatos
      </NavDropdown.Item>
    </Wrapper>
  );
};

export default DropPersona;

const Wrapper = styled(NavDropdown)`
  /* margin-top: 20px; */
  /* padding: 20px; */
  /* left: 24px; */

  border-radius: 15px;

  @media only screen and (max-width: 991px) {
    margin-top: 0;
  }
`;
